import { render, staticRenderFns } from "./LuckywheelItem.vue?vue&type=template&id=3479cf2a&scoped=true"
import script from "./LuckywheelItem.vue?vue&type=script&lang=js"
export * from "./LuckywheelItem.vue?vue&type=script&lang=js"
import style0 from "./LuckywheelItem.vue?vue&type=style&index=0&id=3479cf2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479cf2a",
  null
  
)

export default component.exports